import { render, staticRenderFns } from "./HomeMobile.vue?vue&type=template&id=48dd25bc&scoped=true&"
import script from "./HomeMobile.vue?vue&type=script&lang=js&"
export * from "./HomeMobile.vue?vue&type=script&lang=js&"
import style0 from "./HomeMobile.vue?vue&type=style&index=0&id=48dd25bc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48dd25bc",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCardTitle,VCol,VRow})
